<template>
    <div :class="[$style['mds-tag-container']]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'MdsTagContainer',
    };
</script>

<style lang="scss" module>
    @use './tag-container.scss' as *;
</style>
